import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Menu, Icon } from 'semantic-ui-react';
import { commonActions } from '../../../behavior/common';

import MobileChooseLanguage from './MobileChooseLanguage';
import UserRoleMenuItem from './UserRoleMenuItem';
import HelpPageMenuItem from './HelpPageMenuItem';
import LogOutMenuItem from './LogOutMenuItem';

const MobileHeaderComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state?.init?.user);

  function sidebarMenuItem() {
    return <Menu.Item icon="sidebar" onClick={() => dispatch(commonActions.toggleSidebar())} />;
  }

  function appNameWithEnvironmentMenuItem() {
    return (
      <Menu.Item>
        CERES
        <span style={{ color: 'red' }}>{window.REACT_APP_HEADER_SUFFIX}</span>
      </Menu.Item>
    );
  }

  function chooseLanguageMenuItem() {
    return (
      <Menu.Item>
        <MobileChooseLanguage className="compactPointer" />
      </Menu.Item>
    );
  }

  return (
    <Menu inverted borderless size="small" fixed="top" fluid id="app-main-navbar">
      <Menu.Menu position="left">
        {sidebarMenuItem()}
        {appNameWithEnvironmentMenuItem()}
      </Menu.Menu>
      <Menu.Menu position="right">
        {chooseLanguageMenuItem()}
        {user ? (
          <>
            <UserRoleMenuItem />
            <HelpPageMenuItem />
            <LogOutMenuItem />
          </>
        ) : (
          <span>{t('header.not.connected')}</span>
        )}
      </Menu.Menu>
    </Menu>
  );
};

export default MobileHeaderComponent;
